define('models/purchase',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'purchases/' + this.id + '/' ) :
                ( App.Config.apiBase + 'purchases/' );
        },

        defaults: function () {
            return {
                basket: {},
                credit_card: ''
            };
        }
    });
});
